import { useState } from 'react';
import { dismissCuisineHint, type CuisineHint } from '../lib/cuisineCoach';

interface CuisineCoachProps {
  hint: CuisineHint;
}

// Dismissible heads-up card for cuisine + identity combos with known hidden
// ingredients (fish sauce in SE Asia, lard in Spain, dashi in Japan, pork +
// anchovy in Italy). Renders at the top of MenuScreen for the audience that
// would care (halal / kosher / non_medical), once per cuisine per device.
export function CuisineCoach({ hint }: CuisineCoachProps) {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;

  const close = () => {
    dismissCuisineHint(hint.id);
    setHidden(true);
  };

  return (
    <div
      role="note"
      style={{
        marginTop: 12,
        padding: '14px 16px',
        borderRadius: 12,
        background: 'rgba(185,131,0,0.10)',
        border: '1px solid rgba(185,131,0,0.35)',
        color: 'var(--color-primary)',
        position: 'relative',
      }}
    >
      <button
        onClick={close}
        aria-label="Dismiss"
        style={{
          position: 'absolute',
          top: 6,
          right: 6,
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: 'none',
          background: 'transparent',
          color: 'var(--color-text-secondary)',
          fontSize: 18,
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        ×
      </button>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          fontSize: 11,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: '#B98300',
          fontWeight: 700,
          marginBottom: 6,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        Heads up
      </div>
      <p style={{ margin: '0 0 6px', fontSize: 14, fontWeight: 600, lineHeight: 1.3, paddingRight: 28 }}>
        {hint.title}
      </p>
      <p style={{ margin: 0, fontSize: 13, color: 'var(--color-text-secondary)', lineHeight: 1.5 }}>
        {hint.body}
      </p>
    </div>
  );
}
